<template>
  <div class="tw-mb-3">
    <template v-if="call.companyId">
      <v-select
        :value="call.outcome"
        :items="outcomes"
        label="Outcome"
        hide-details
        class="tw-mb-2"
        @change="(outcome) => $store.commit('dialer/setWrapUp', { outcome })"
      />
      <v-textarea
        :value="call.notes"
        label="Notes"
        rows="3"
        hide-details
        class="tw-mb-2"
        @input="(notes) => $store.commit('dialer/setWrapUp', { notes })"
      />
      <BaseButton
        variant="primary"
        block
        @click="$store.dispatch('dialer/done')"
      >
        Done
      </BaseButton>
    </template>

    <!-- Keypad calls aren't tied to a lead, so there's nothing to log. -->
    <template v-else>
      <div class="tw-text-sm tw-text-gray-600 tw-mb-2">
        This call isn't tied to a lead, so it won't be logged.
      </div>
      <BaseButton
        variant="inverted-primary"
        block
        @click="$store.dispatch('dialer/done')"
      >
        Skip
      </BaseButton>
    </template>
  </div>
</template>

<script>
import { BaseButton } from '@bambeehr/pollen';
import { mapState } from 'vuex';

import { OUTCOMES } from '@/store/dialer';

export default {
  name: 'DialerWrapUp',

  components: {
    BaseButton,
  },

  data() {
    return {
      outcomes: OUTCOMES,
    };
  },

  computed: {
    ...mapState('dialer', { call: 'activeCall' }),
  },
};
</script>
